// @ts-ignore
import $ from 'jquery';
// @ts-ignore
import { Deferred } from 'simply-deferred';
import {RequestType} from "../../data/types";
import {AjaxRequestParams, ApiRequestOptions} from "../@type";

// const debug = "ajaxRequestV2"
const debug = false

function resendRequest(result : any, obj: any, settings:any, autoError:boolean) {

    debug && console.log(debug, "ResendRequest()")

    // add access token to request
    gd.auth?.updateRequestHeaders(settings.headers)

    let ajax = $.ajax(settings).done(function(response:any) {

        debug && console.log(debug, "ResendRequest DONE response=",response);


        if (response) {
            if (response.session) {
                gd.session.processEvents(response.session, "API");
            }

            // Auto process Session
            if (response.data && response.data.session) {
                gd.session.processEvents(response.data.session, "API");
            }

            // Auto process conflicts
            if (response.conflictResponse) {
                gd.apiConflict(response.conflictResponse)
            }
        }

        debug && console.log(debug, "resolve result=",result,"context=",obj.context,"data=",response);

        result.resolveWith(obj.context,[response])

    }).fail( async function (jqXHR:any, exception:any) {

        // ignore aborts...
        if (ajax.statusText === 'abort') return;

        let errorMessage : any      = (jqXHR.responseJSON && jqXHR.responseJSON.errorMessage)?jqXHR.responseJSON.errorMessage:false;
        let conflictResponse : any  = (jqXHR.responseJSON && jqXHR.responseJSON.conflictResponse)?jqXHR.responseJSON.conflictResponse:false;
        const errorCode : number    = parseInt(jqXHR.status)

        const errorsObj = {
            code                : errorCode,
            errorMessage        : errorMessage,
            conflictResponse    : conflictResponse
        };



        switch (errorCode) {

            case 401:
                // this time we do not try refresh toke I guess ?
            default:
                if (autoError) gd.apiError(errorsObj);
                result.rejectWith(obj.context,[errorsObj]);

                return
        }

    });

}



export default function ajaxRequestV2(obj : AjaxRequestParams, options?:ApiRequestOptions) {

    // Parse options
    const autoError                 : boolean = _.get(options, "autoError", true)
    const processSessionResponse    : boolean = _.get(options, "processSessionResponse", true)


    let result = Deferred();

    let settings : any = {
        url             : obj.url,
        'xhrFields'     : {  // enable browser to send cookie
            withCredentials: true
        },
    };

    if (obj.headers) {
        settings.headers = obj.headers;
    }

    gd.auth?.updateRequestHeaders(settings.headers)

    switch (obj['type'].toUpperCase()) {
        case 'GET':
        case RequestType.GET:
            settings['type']        = 'GET';
            settings['data']        = obj.payload;
            // settings['contentType'] = 'application/json';
            // settings['dataType'] = 'json';
            break;

        case 'POST':
        case RequestType.POST:
            settings['type']        = 'POST';
            settings['data']        = JSON.stringify(obj.payload);
            settings['contentType'] = 'application/json';
            settings['dataType']    = 'json';
            break;

        case 'PUT':
        case RequestType.PUT:
            settings['type']        = 'PUT';
            settings['data']        = JSON.stringify(obj.payload);
            settings['contentType'] = 'application/json';
            settings['dataType']    = 'json';
            break;
        case 'DELETE':
        case RequestType.DELETE:
            settings['type']        = 'DELETE';
            settings['data']        = obj.payload;

            // zachem to mi eto ubrali...

            // move all data params to request url...
            // // Experimental disabling - disable ran'she bil enabled
            // // settings['data'] = obj.data;
            //
            // // settings['contentType'] = 'application/json';
            // // settings['dataType'] = 'json';
            //
            // // NEW EXPERIMENTAL !
            // const urlWithParams = new URL(settings['url']);
            // settings['url'] = urlWithParams;
            //
            // _.mapKeys(settings['data'], (value, key)=>{
            //     urlWithParams.searchParams.set(key, value)
            // })
            // // end experimental


            break;

        case RequestType.UPLOAD:
        case 'UPLOAD':
            settings['type'] = 'POST';
            settings['data'] = obj.payload;
            settings['processData'] = false;
            settings['contentType'] = false;
            break;
    }



    let ajax = $.ajax(settings).done((response:any)=> {

        if (debug) console.log("Request done. Response=",response);


        if (response) {

            if (processSessionResponse) {
                if (response.session) {
                    gd.session.processEvents(response.session, "API");
                }
                if (response.data && response.data.session) {
                    gd.session.processEvents(response.data.session, "API");
                }
            }

            // Auto process conflicts
            if (response.conflictResponse) {
                gd.apiConflict(response.conflictResponse)
            }
        }

        debug && console.log(debug, "resolve result=",result,"context=",obj.context,"data=",response);
        result.resolveWith(obj.context,[response])

    }).fail(async function (jqXHR:any, exception:any) {

        if (debug) console.log("Request Fail.");

        // ignore aborts...
        if (ajax.statusText == 'abort') return;


        let errorMessage: any       = (jqXHR.responseJSON && jqXHR.responseJSON.errorMessage)?jqXHR.responseJSON.errorMessage:false;
        let conflictResponse : any  = (jqXHR.responseJSON && jqXHR.responseJSON.conflictResponse)?jqXHR.responseJSON.conflictResponse:false;
        const errorCode : number    = parseInt(jqXHR.status)

        const errorsObj = {
            code                : errorCode,
            errorMessage        : errorMessage,
            conflictResponse    : conflictResponse
        }

        // process not authorized
        switch (errorCode) {

            case 401:
                console.log(debug, "not authorized")

                // we cannot detect if we have refresh cookie or not so we need to try in any case...

                debug && console.log(debug, "use refresh token to obtain new access token")
                const weHaveNewAccessToken = await gd.auth.refreshAccessToken()


                if (weHaveNewAccessToken) {
                    debug && console.log(debug, "we have new access token - let's resend the api cal...")
                    resendRequest(result, obj, settings, autoError)

                } else {
                    debug && console.log(debug, "no new access token - vse poshlo prahom...")
                    // if no refresh token - logout user (delete access token as well from local storage)
                    gd.auth.logout();

                    // default error handling... Not needed anymore
                    // if (autoError) gd.apiError(errorsObj);
                    // result.rejectWith(obj.context,[errorsObj]);

                }
                return

            default:
                // console.log(121232, autoError, errorsObj)
                if (autoError) gd.apiError(errorsObj);
                result.rejectWith(obj.context,[errorsObj]);

                return


        }

    });

    //Abort ... which calls fail... not sure if needed
    //result.progress(function (what) {
    //    if (what == 'abort') ajax.abort();
    //});

    result.abort = function() {
        ajax.abort();
    };

    return result

};
